exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".loading {\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 10000;\n}\n.text {\n  font-size: 40px;\n  text-align: center;\n  position: absolute;\n  top: 40%;\n  width: 100%;\n}\n.s-jump {\n  animation: jump 10s ease 0s infinite;\n  display: inline-block;\n  position: relative;\n  padding: 0 10px;\n  color: #fff;\n}\n@keyframes jump {\n  0% {\n    transform: translateY(0px);\n  }\n  3% {\n    transform: translateY(-100px);\n  }\n  6% {\n    transform: translateY(30px);\n  }\n  10% {\n    transform: translateY(0px);\n  }\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js!./~/less-loader!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/editor/loading/index.vue
// module id = 1555
// module chunks = 38